import {
  useMediaQuery,
  WhmDialog,
  WhmMenu,
  WhmMenuList,
  whmTheme,
} from "@securitize/reactjs-whm";

export default function FlexMenu({
  open,
  onClose,
  children,
  anchorEl,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  anchorEl: HTMLElement | null;
}) {
  const isMobile = useMediaQuery(whmTheme.breakpoints.down("xl"));

  if (isMobile) {
    return (
      <WhmDialog open={open} onClose={onClose}>
        <WhmMenuList sx={{ minWidth: "300px" }}>{children}</WhmMenuList>
      </WhmDialog>
    );
  } else {
    return (
      <WhmMenu
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: "300px",
            },
          },
        }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {children}
      </WhmMenu>
    );
  }
}
